import React from "react";
import { graphql } from "gatsby"
import styled from 'styled-components';

import Seo from "../components/seo";
import {AnotherLayout} from "../components/Layout"
import { CategorySection } from '../components/Category';
import BreadCrumb from '../components/BreadCrumbs.js';
import { rhythm } from "../utils/typography";
import EmojiWrapper from "../components/EmojiWrapper";
import { Link } from "gatsby";


const BlogsDiv = styled.div`
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  margin-bottom: 1rem;
`;

const Blog = styled.div`
  width:48%;
  border-radius:30px;
  height:fit-content;
  background:var(--color-background);
  border:1px solid var(--color-gray3);
  transition:box-shadow .15s ease;
  margin:${rhythm(0.5)} 0;
  h1{
    font-size:1.5rem;
    margin:0;
  }
  @media only screen and (max-width: 768px) {
    width:100%;
  }
  :hover{
    border-color:var(--color-gray1);
    box-shadow:0px 30px 60px 0px rgba(0, 0, 0, 0.12);
  }
`;

const CategorySelected = ({ pageContext, data, location }) => {
  const { category } = pageContext
  const { edges: posts, totalCount } = data.allMdx
  let toShow = totalCount > 1 ? 'articles' : 'article';

  return (
    <AnotherLayout >
      <Seo
        title={category}
        description={`Interesting articles on ${category}`}
        pathname={location.pathname}
      />
      <div style={{ padding: 0 }}>
        <BreadCrumb list={['Home', 'Categories']} />
        <h1 style={{ margin: '12px 0', color: 'var(--color-headingFont)' }}>{category}</h1>
        <p className="caption">{`${totalCount} ${toShow}`}</p>
      </div>
      <BlogsDiv>
        {posts.map(post => {
          let slug = post.node.fields.slug;
          let frontMatter = post.node.frontmatter;
          return (
            <Blog key={slug}>
              <Link to={slug} >
                <div style={{
                  padding: rhythm(1.4)
                }}>
                  <small>
                    <EmojiWrapper emoji="🌱" name="written on" />
                    {frontMatter.date}
                  </small>
                  <h1 style={{ margin: 0 }}>{frontMatter.title}</h1>
                  <p>{post.node.excerpt}</p>
                  <small>
                    <EmojiWrapper
                      emoji="🕓"
                      name="time to read"
                    />
                    {post.node.timeToRead} min. read</small>
                </div>
              </Link>
            </Blog>
          );
        })}
      </BlogsDiv>
      <CategorySection />
    </AnotherLayout>
  );

}

export const pageQuery = graphql`
query($category: String) { 
  allMdx(
        limit: 2000
        sort: { fields: [frontmatter___date], order: DESC }
        filter: { frontmatter: { category: { in: [$category] } } }
        ) {
            totalCount
            edges {
                node {
                    timeToRead
                    excerpt(pruneLength: 100)
                    fields {
                        slug
                    }
                    frontmatter {
                      title
                      description                      
                      date(formatString: "MMMM DD, YYYY")
                    }
                }
            }
        }
    }
    `
export default CategorySelected
